import { Size } from "../types";

/**
 * Types for the table.
 */
 export interface TooltipProps extends React.HTMLAttributes<HTMLDivElement> {

    label?: string;
    /** Optional. If set, then there will be an arrow at the edge closest to children components */
    withArrow?: boolean;
    /** Optional.  */
    width?: string;
    /** Optional. Defaults to 'Small'. */
    size?: Size;
    /** Optional. Delay in appearance of the tooltip. Defaults to 0.7s for 'hover' trigger type. */
    delay?: string;
    /** Optional. TabIndex property set to TooltipContainer  */
    tabIndex?: number;
    /** Optional. Defaults to 'auto'. */
    height?: string;
    /** Optional. To which edge of wrapped components tooltip will be aligned. Defaults to 'center'.  */
    align? : 'start' | 'end' | 'center' | undefined;
    /** Optional. Defaults to 'bottom'.  */
    position? : 'top' | 'right' | 'bottom' | 'left' | undefined;
    children?: React.ReactNode;
    /** Optional. What should trigger the appearance of the tooltip - hover or click event. */
    trigger?: 'hover' | 'click';
    /** Optional. How long tooltip will be visible after appearing to the user in milliseconds. Works only for trigger type 'click'. Defaults to '5000' */
    hideAfter?: number;
  }
